export default __webpack_public_path__ + "static/media/gold-8.515c4e78.png";